import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";
import IndependentDataCheck from "../adTesting/independentDataCheck";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = ["ne", "phx", "cat"];
let series = [];
let envs = ["Live", "Staging"];

function VastVideo(mode) {
	const [focusRegion, setFocusRegion] = React.useState();
	const [focusSeries, setFocusSeries] = React.useState();
	const [focusToyotaAPIName, setFocusToyotaAPIName] = React.useState();
	const [focusEnv, setFocusEnv] = React.useState();
	const [seriesAPI, setSeriesAPI] = React.useState([]);

	console.log(mode);
	React.useEffect(() => {
		//get qs vars and poulate the focusRegion and focusSeries
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		setFocusSeries(urlParams.get("series"));
		setFocusToyotaAPIName(urlParams.get("code"));
		setFocusRegion(urlParams.get("region"));
		if (focusRegion) {
			loadSeriesAPI(focusRegion);
		}
		setFocusEnv(urlParams.get("env"));
		if (focusSeries && focusRegion && focusEnv) {
			createVastAd(focusSeries, focusRegion, focusEnv);
		}
	}, []);
	React.useEffect(() => {
		if (focusRegion) {
			loadSeriesAPI(focusRegion);
		}
	}, [focusRegion]);
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		getOfferData();
	// 	}
	// }, [regionJSON]);

	React.useEffect(() => {
		console.log("----- ", focusRegion, focusSeries);
		if ((focusRegion, focusSeries)) {
			createVastAd(focusSeries, focusRegion);

			if (focusSeries && focusRegion && focusEnv) {
				const queryString = `?series=${focusSeries}&code=${focusToyotaAPIName}&region=${focusRegion}&env=${focusEnv}&mode=vastvideo`;
				window.history.pushState({}, "", queryString);
			}
		}
	}, [focusRegion, focusSeries, focusEnv]);

	async function loadSeriesAPI(focusRegion) {
		console.log("loadSeriesAPI");
		const response = await fetch(
			`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/seriesapi/full/${focusRegion}/seriesapi.json`
		);
		const data = await response.json();
		//add the No Series
		data.push({
			seriesname: "No Series",
			seriescode: "noseries",
			ToyotaAPIName: "noseries"
		});
		//alphabetize the series
		data.sort((a, b) => (a.seriesname > b.seriesname ? 1 : -1));
		setSeriesAPI(data);
		console.log("data: " + JSON.stringify(data));
	}
	async function createVastAd(focusSeries, focusRegion) {
		console.log("createVastAd");
		var xml = "";
		// const vastTagUrl = `https://servedby.flashtalking.com/imp/8/259500;8999368;208;xml;test;STAGINGTESTVAST/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=${Math.floor(
		let vastTagUrl = "";
		if (focusRegion == "ne" && focusEnv == "Staging") {
			vastTagUrl =
				"https://servedby.flashtalking.com/imp/8/259500;8999368;208;xml;test;STAGINGTESTVAST/?gdpr=%24%7BGDPR%7D&ft_keyword=" +
				focusSeries +
				"&gdpr_consent=%24%7BGDPR_CONSENT_78%7D&us_privacy=%24%7BUS_PRIVACY%7D&pbMethods=%5BPLAYBACKMETHODS%5D%7C%5BCONTINUOUSPLAY%5D%7C%5BTIMESINCEINTERACTION%5D&cachebuster=" +
				Math.floor(Math.random() * 1000000);
		} else if (focusRegion == "ne" && focusEnv == "Live") {
			vastTagUrl =
				//"https://servedby.flashtalking.com/imp/8/281013;9665328;208;xml;WFXT;WFXT3Q25BOSTVIDEOZIPTRIPPREROLLPREROLL301920x1080/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=[CACHEBUSTER]";
				//"https://servedby.flashtalking.com/imp/8/290251;9949530;208;xml;WPRI;WPRI4Q25PROVDISPLAYROSAWARENESSDIGITALVAST/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=[CACHEBUSTER]";
				"https://servedby.flashtalking.com/imp/8/259500;8999367;208;xml;test;LIVETESTVAST/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=[CACHEBUSTER]&ft_keyword=" +
				focusToyotaAPIName;
			// "https://servedby.flashtalking.com/imp/8/290251;9949530;208;xml;WPRI;WPRI4Q25PROVDISPLAYROSAWARENESSDIGITALVAST/?gdpr=${GDPR}&ft_keyword=" +
			// focusSeries +
			// "&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=[CACHEBUSTER]";
		} else if (focusRegion == "phx") {
			// this needs to be updated once we get a new phx tag
			vastTagUrl =
				"https://servedby.flashtalking.com/imp/8/245866;9143342;208;xml;test;30PHXVAST15TEST/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=[CACHEBUSTER]";
		} else if (focusRegion == "cat") {
			// this needs to be updated once we get a new phx tag
			vastTagUrl =
				"https://servedby.flashtalking.com/imp/8/245648;10217056;208;xml;Nexxen;CATNEXXENDVAST15T1/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&ft_c1=medium_value&ft_id=$!{IFA}&ft_c2=content_value&ft_keyword=" +
				focusToyotaAPIName +
				"&ft_section=keyword_macro&pbMethods=[PLAYBACKMETHODS]|[CONTINUOUSPLAY]|[TIMESINCEINTERACTION]&cachebuster=" +
				Math.floor(Math.random() * 1000000);
		} else {
			// vastTagUrl =
			// 	"https://servedby.flashtalking.com/imp/8/259500;8999368;208;xml;test;STAGINGTESTVAST/?gdpr=%24%7BGDPR%7D&ft_keyword=" +
			// 	focusSeries +
			// 	"&gdpr_consent=%24%7BGDPR_CONSENT_78%7D&us_privacy=%24%7BUS_PRIVACY%7D&pbMethods=%5BPLAYBACKMETHODS%5D%7C%5BCONTINUOUSPLAY%5D%7C%5BTIMESINCEINTERACTION%5D&cachebuster=" +
			// 	Math.floor(Math.random() * 1000000);
		}
		console.log(vastTagUrl);
		const response = await axios.get(vastTagUrl);
		xml = response.data;

		const parser = new XMLParser();
		const json = parser.parse(xml);
		console.log(json);

		// Assuming you want to render the video using the VAST tag
		const videoElement = document.createElement("video");

		videoElement.setAttribute("controls", "controls");
		console.log(
			json.VAST.Ad.InLine.Creatives.Creative.Linear.VideoClicks.ClickThrough
		);
		videoElement.addEventListener("click", () => {
			window.open(
				json.VAST.Ad.InLine.Creatives.Creative.Linear.VideoClicks.ClickThrough,
				"_blank"
			);
		});

		const sourceElement = document.createElement("source");
		console.log(
			json.VAST.Ad.InLine.Creatives.Creative.Linear.MediaFiles.MediaFile
		);
		sourceElement.setAttribute(
			"src",
			json.VAST.Ad.InLine.Creatives.Creative.Linear.MediaFiles.MediaFile
		);
		sourceElement.setAttribute("type", "video/mp4");

		videoElement.appendChild(sourceElement);
		const adsContainer = document.getElementById("ads");
		adsContainer.innerHTML = ""; // Clear the ads tag
		adsContainer.appendChild(videoElement);
		// await getLiveXML(focusRegion);

		//mute the video player
		videoElement.muted = true;
	}

	async function getLiveXML(region) {
		console.log("getLiveXML");

		//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
		// axios
		// 	.get(
		// 		`https://dat-vps.com//tcaautilities/toyotascreenscrape/fb_marketing_feed_${region}.xml`
		// 	)
		// 	.then((response) => {
		// 		console.log(response.data);
		// 		const parser = new XMLParser();
		// 		const json = parser.parse(response.data);
		// 		setRegionJSON(json);
		// 		console.log(json);
		// 		getOfferData(json);
		// 	})
		// 	.catch((error) => {
		// 		console.error("There was an error!", error);
		// 	});
	}

	return (
		<div id="htmlPage">
			<h1>Vast Test Page</h1>
			<Grid2 container spacing={5}>
				<Grid2 container spacing={2} direction="column">
					<FormControl sx={{ m: 1, width: 300 }}>
						<InputLabel id="region-select-label">Region</InputLabel>
						<Select
							labelId="region-select-label"
							id="region-select"
							value={focusRegion ? focusRegion : ""}
							onChange={(e) => setFocusRegion(e.target.value)}
							input={<OutlinedInput label="Region" />}
							MenuProps={MenuProps}
						>
							{regions.map((region) => (
								<MenuItem key={region} value={region}>
									<ListItemText primary={region} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl sx={{ m: 1, width: 300 }}>
						<InputLabel id="env-select-label">Environment</InputLabel>
						<Select
							labelId="env-select-label"
							id="env-select"
							input={<OutlinedInput label="Environment" />}
							MenuProps={MenuProps}
							value={focusEnv ? focusEnv : ""}
							onChange={(e) => setFocusEnv(e.target.value)}
						>
							{envs.map((env) => (
								<MenuItem key={env} value={env}>
									<ListItemText primary={env} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl sx={{ m: 1, width: 300 }}>
						<InputLabel id="series-select-label">Series</InputLabel>
						<Select
							labelId="series-select-label"
							id="series-select"
							value={focusSeries ? focusSeries : ""}
							onChange={(e) => {
								setFocusSeries(e.target.value);
								const selectedSeries = seriesAPI.find(
									(s) => s.seriesname === e.target.value
								);
								setFocusToyotaAPIName(selectedSeries?.ToyotaAPIName);
							}}
							input={<OutlinedInput label="Series" />}
							MenuProps={MenuProps}
						>
							{seriesAPI.map(
								(series) => (
									console.log(series.ToyotaAPIName),
									(
										<MenuItem key={series.seriesname} value={series.seriesname}>
											<ListItemText primary={series.seriesname} />
										</MenuItem>
									)
								)
							)}
						</Select>
					</FormControl>
				</Grid2>
				<Grid2 container xs={10} id="ads"></Grid2>
			</Grid2>
			{seriesAPI.length && focusSeries && focusRegion && (
				<IndependentDataCheck
					seriesAPIData={seriesAPI}
					theFocusSeries={focusSeries}
					theFocusRegion={focusRegion}
				/>
			)}
		</div>
	);
}

export default VastVideo;
